import {Component, Input, OnInit, AfterViewInit, Output, EventEmitter, ChangeDetectorRef, OnDestroy, HostListener} from '@angular/core';
import {Result} from '../../../../models/search/result';
import {SessionStorageService} from '../../../../services/session-storage.service';
import {Subscription} from 'rxjs';
import {LocationSelectComponent} from '../../../../form/location-select/location-select.component';
import {BrandService} from '../../../../services/brand.service';
import {Brands} from '../../../../models/Brands';

@Component({
  selector: 'app-list-result',
  templateUrl: './result.component.html'
})
export class ResultComponent implements OnInit, AfterViewInit, OnDestroy {

  @Input() listLoading = true;
  @Input() result: Result;
  @Input() sorting: string;
  @Input() dealerCode: string;
  @Input() newCarsOfferCount: number;
  @Output() filtersVisibleEvent = new EventEmitter();
  @Output() pageChange: EventEmitter<number> = new EventEmitter();
  @Output() sortChange: EventEmitter<string> = new EventEmitter();
  @Input() initOfferCount: any;

  distanceSortingAvailable = false;
  horizontalView = true;
  interval = null;
  locationChange: Subscription;
  newCarsUrl = '';
  brandSlug = '';
  openedSortList = true;
  lfaUrl = null;

  @HostListener('window:resize', ['$event'])
  onResize() {
    if (this.brandSlug === 'fiat' || this.brandSlug === 'fiat-professional') {
      if (window.innerWidth > 991) {
        this.openedSortList = true;
      } else {
        this.openedSortList = false;
      }
    } else {
      if (window.innerWidth > 767) {
        this.openedSortList = true;
      } else {
        this.openedSortList = false;
      }
    }
  }

  constructor(
    private storage: SessionStorageService,
    private changeDetectorRef: ChangeDetectorRef,
  ) {
    this.result = new Result();
    this.horizontalView = this.storage.get('horizontal-view', true);
    this.newCarsUrl = BrandService.getCurrentBrand().newCarsUrl;
    this.interval = setInterval(() => {
      this.changeDetectorRef.detectChanges();
    }, 500);
  }

  ngOnInit() {
    this.locationChange = LocationSelectComponent.selectedAfterChange.subscribe((value: boolean) => {
      this.distanceSortingAvailable = value;
      if (value) {
        this.changeSorting('distance-asc');
      } else {
        this.changeSorting('price-asc');
      }
    });

    this.brandSlug = BrandService.getCurrentBrand().slug;

    if (this.brandSlug === 'fiat' || this.brandSlug === 'fiat-professional') {
      if (window.innerWidth > 991) {
        this.openedSortList = true;
      } else {
        this.openedSortList = false;
      }
    } else {
      if (window.innerWidth > 767) {
        this.openedSortList = true;
      } else {
        this.openedSortList = false;
      }
    }

    // if (BrandService.getCurrentBrand().config !== undefined && BrandService.getCurrentBrand().config.lfaUrl !== undefined) {
    //   this.lfaUrl = BrandService.getCurrentBrand().config.lfaUrl;
    // }
  }

  ngOnDestroy(): void {
    clearInterval(this.interval);
    this.locationChange.unsubscribe();
  }

  ngAfterViewInit() {

  }

  changeSorting(val: string) {
    if (this.sorting !== val) {
      this.sortChange.emit(val);
    }
    this.sorting = val;
  }

  pageChangeEvent(val: number) {
    this.pageChange.emit(val);
    window.scroll(0, 0);
  }

  changeHorizontalView(newValue: boolean) {
    this.storage.set('horizontal-view', newValue);
    this.horizontalView = newValue;
  }

  openOrCloseSortList() {
    if (this.brandSlug === 'fiat' || this.brandSlug === 'fiat-professional') {
      if (window.innerWidth < 992) {
        this.openedSortList = !this.openedSortList;
      }
    } else {
      if (window.innerWidth < 768) {
        this.openedSortList = !this.openedSortList;
      }
    }
  }
}
